import React, { HTMLAttributes, useCallback, useMemo } from 'react';
import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import { AssistiveText } from '../AssistiveText';

export type ErrorsProps = HTMLAttributes<HTMLDivElement> & {
    errors?: string[];
};

export const Errors: FunctionComponent<ErrorsProps> = ({ id, errors, ...props }) => {
    if (!errors || errors.length === 0) {
        return null;
    }

    const makeId = useCallback(
        (key: number) => {
            if (!id) {
                return undefined;
            }

            return `${id}-${key}`;
        },
        [id]
    );

    const errorElements = useMemo(
        () =>
            errors.map((error, index) => {
                const id = makeId(index);

                return (
                    <AssistiveText {...props} id={id} key={index} className={styles.errorMessage}>
                        {error}
                    </AssistiveText>
                );
            }),
        [errors, id, props]
    );

    return <div id={id}>{errorElements}</div>;
};
